var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFacebookIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#046DEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10973_221627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 24C34 28.9914 30.343 33.1285 25.5625 33.8785V26.8906H27.8926L28.3359 24H25.5625V22.1242C25.5625 21.3332 25.95 20.5625 27.1922 20.5625H28.4531V18.1016C28.4531 18.1016 27.3086 17.9063 26.2145 17.9063C23.9305 17.9063 22.4375 19.2906 22.4375 21.7969V24H19.8984V26.8906H22.4375V33.8785C17.657 33.1285 14 28.9914 14 24C14 18.4773 18.4773 14 24 14C29.5227 14 34 18.4773 34 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8926 26.8906L28.3359 24H25.5625V22.1242C25.5625 21.3334 25.9499 20.5625 27.1921 20.5625H28.4531V18.1016C28.4531 18.1016 27.3088 17.9062 26.2146 17.9062C23.9304 17.9062 22.4375 19.2906 22.4375 21.7969V24H19.8984V26.8906H22.4375V33.8785C22.9466 33.9584 23.4684 34 24 34C24.5316 34 25.0534 33.9584 25.5625 33.8785V26.8906H27.8926Z",
    fill: "#046DEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10973_221627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook-icon.df199187.svg";
export { ForwardRef as ReactComponent };